module.exports = __webpack_public_path__ + "img/corporate-social-responsibility-logo.396d217c.svg";